module.exports = __webpack_public_path__ + "media/images/signatures/kamill_signature_black-39d3ad10b473d0dfb5e59f3b42f69b6b.png";